const useAuth = (): boolean => {
  const accessToken = localStorage.getItem('accessToken')
  return !!accessToken
}

export default useAuth
